export default __webpack_public_path__ + "static/media/admin_marketing.a32ad3d2.svg";